export const trainViewCn = {
    kaitongtishi:"开通VIP会员或购买课程观看完整课程",
    kaitongguankan:"开通VIP免费观看",
    buyClass:"购买课程",
    mainfei:"免费",
    goumai:"购买",
    shikan:"试看视频"
}


// WEBPACK FOOTER //
// ./src/lang/home/trainView/indexCn.js